import UXCGLayout from './UXCGLayout';

export default UXCGLayout;
